
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/program/free-course/mobile-application",
      function () {
        return require("private-next-pages/program/free-course/mobile-application.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/program/free-course/mobile-application"])
      });
    }
  